import {
  SvgSingleNeutralBold,
  TextV2,
  type TextV2Colour,
} from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getSubjectObjectTextKey, type Pronoun } from 'domain/pronouns';
import { DIALECTS } from 'variables';
import { Dialects } from 'types/dialects';

const StyledSvgSingleNeutralBold = styled(SvgSingleNeutralBold)<{
  textcolor?: TextV2Colour;
}>(({ theme, textcolor }) => ({
  height: '13px',
  width: '15px',
  ...(textcolor === 'textSecondary' && {
    fill: theme.palette.grey[600],
  }),
}));

const getPreferredDialectAndPronoun = (
  t: (key: string) => string,
  pronoun?: Pronoun,
  preferredProfileDialect: Dialects = 'en-GB',
) => {
  const dialectKey = DIALECTS[preferredProfileDialect]?.textKey;
  const preferredDialectText = dialectKey
    ? t(dialectKey)
    : t('ui.event-management.learner.profiles.unsupported-language');
  return pronoun
    ? `${preferredDialectText} - ${t(getSubjectObjectTextKey(pronoun))}`
    : preferredDialectText;
};

export const PreferredDialectAndPronoun = ({
  pronoun,
  preferredProfileDialect,
  textColor,
}: {
  pronoun?: Pronoun;
  preferredProfileDialect?: Dialects;
  textColor?: TextV2Colour;
}) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: spacingSizeMap.XS,
      }}
    >
      <StyledSvgSingleNeutralBold textcolor={textColor} />
      <TextV2 variant="bodyBold" color={textColor}>
        {getPreferredDialectAndPronoun(t, pronoun, preferredProfileDialect)}
      </TextV2>
    </Box>
  );
};
